import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IntroductionDialogService {

  public displayEnabled: boolean = true;

  constructor() { }
}
